import React from "react";
import axios from "@/utils/myAxios";
import moment from "moment";
import Cookie from "js-cookie";
import { Link } from "react-router-dom";
import { pageSizeList, unionTypeList } from "@/utils/constant";
import { Button, Table, message, DatePicker, Select, Pagination, Form, Modal, Input, Radio, Cascader, TreeSelect } from "antd";
import { tableSummaries, isMobileDevice, randomString } from "@/utils/utils";

// 表单数据
const formData = {
    type: undefined,
    union_ids: [],
    date: undefined,
    email: undefined,
    data_type: undefined,
}

export default class LowerLevelStatistic extends React.Component {
    state = {
        loading: false, // 是否加载中
        exportLoading: false, // 导出是否加载中
        recordLoading: false, // 记录是否加载中
        formType: undefined, // 表单弹窗类型
        recordType: undefined, // 记录弹窗类型
        formTitle: undefined, // 表单弹窗标题
        recordTitle: undefined, // 记录弹窗标题
        showForm: false, // 是否显示表单弹窗
        showRecord: false, // 是否显示记录弹窗
        formData: { ...formData }, // 表单数据
        queryParams: {
            // 查询参数
            page: 1,
            limit: 7,
            total: 0,
            kpoker_mode: -1,
            union_id: undefined,
            union_ids: [],
            date: [],
        },
        data: [], // 表格数据
        intervalSummaryData: [], // 区间汇总数据
        subUnionList: [], // 子联盟列表
        pageSizeList: pageSizeList, // 分页天数列表
        unionTypeList: unionTypeList, // 联盟类型列表
        typeList: [
            { value: 1, label: this.props.language['superUnionData'] },
            { value: 2, label: this.props.language['unionData'] },
        ],
        dataTypeList: [
            { value: 1, label: this.props.language['gameData'] },
            { value: 2, label: this.props.language['integralData'] },
            { value: 3, label: this.props.language['gameAndIntegralData'] },
        ]
    };

    componentDidMount () {
        this.fetchData();
        this.fetchSubUnionList();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/super_union_sub_gain_stat", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.queryParams.union_ids.length ? this.state.queryParams.union_ids[0] : - 1,
                    union_id: this.state.queryParams.union_ids[1],
                    union_ids: undefined,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                let data = res.data || []
                let newData = []
                data.forEach((item, index) => {
                    let tableData = { ...item[item.length - 1], key: randomString() }
                    let children = [...item.slice(0, item.length - 1)]
                    children.forEach(item2 => item2.key = randomString())
                    newData.push({
                        ...tableData,
                        children,
                    })
                })
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: newData,
                });
            });
    };

    /**
     * 获取子联盟列表
     */
    fetchSubUnionList = () => {
        axios.get("/v1/api/union_select_list?kpoker_mode=-1").then((res) => {
            // 转换数据结构
            const modeMap = Object.fromEntries(
                this.state.unionTypeList.map(item => [item.value, item.label])
            );
            const resultMap = {};
            const list = res.data || []
            list.forEach(item => {
                const key = item.kpoker_mode;
                if (!resultMap[key]) {
                    resultMap[key] = {
                        value: key,
                        label: modeMap[key],
                        children: []
                    };
                }
                resultMap[key].children.push({
                    value: item.union_id,
                    label: `${item.union_name}（${item.union_id}）`,
                });
            });

            this.setState({
                subUnionList: Object.values(resultMap),
            });
        });
    };

    /**
     * 获取区间汇总数据
     */
    fetchIntervalSummaryData = () => {
        this.setState({ recordLoading: true });
        axios
            .get("/v1/api/super_union_sub_gain_range_stat", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.queryParams.union_ids.length ? this.state.queryParams.union_ids[0] : - 1,
                    union_id: this.state.queryParams.union_ids[1],
                    union_ids: undefined,
                    total: undefined,
                    date: undefined,
                    page: undefined,
                    limit: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    recordLoading: false,
                    intervalSummaryData: res.data || [],
                });
            });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type) => {
        if (type === "exportCheckData") {
            // 导出
            this.setState({
                formTitle: this.props.language["exportCheckData"],
                formType: type,
                showForm: true,
            });
        } else if (type === "intervalSummaryData") {
            // 区间汇总记录
            this.setState({
                recordTitle: this.props.language["intervalSummaryData"],
                recordType: type,
                showRecord: true,
            }, () => this.fetchIntervalSummaryData());
        }
    };

    /**
     * 关闭弹窗
     */
    handleClose = (type) => {
        if (type === "exportCheckData") {
            // 导出
            this.formRef.props.form.resetFields();
            this.setState({ showForm: false, formData: { ...formData } });
        } else if (type === "intervalSummaryData") {
            // 区间汇总记录
            this.setState({ showRecord: false });
        }
    }

    /**
     * 导出数据
     */
    handleExport = () => {
        this.setState({ exportLoading: true });
        axios
            .get("/v1/api/super_union_sub_gain_stat_export", {
                params: {
                    ...this.state.queryParams,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    kpoker_mode: this.state.queryParams.union_ids.length ? this.state.queryParams.union_ids[0] : - 1,
                    union_id: this.state.queryParams.union_ids[1],
                    union_ids: undefined,
                    total: undefined,
                    date: undefined,
                },
            })
            .then((res) => {
                this.setState({ exportLoading: false });
                if (res.code === 1) {
                    message.success(this.props.language["exportSuccessMessage"]);
                    window.open(process.env.REACT_APP_API_URL + res.url);
                }
            });
    };

    /**
     * 导出对账数据
     */
    handleCheckExport = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                axios
                    .post("/v1/api/export_union_account_checking", {
                        union_ids: values.type === 2 ? values.union_ids : undefined,
                        begin_time: values.date[0] && values.date[0].startOf("day").valueOf() / 1000,
                        end_time: values.date[1] && values.date[1].startOf("day").valueOf() / 1000,
                        email: values.email,
                        data_type: values.data_type,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(this.props.language["exportSuccessMessage"]);
                            this.handleClose('exportCheckData')
                        }
                    });
            }
        })
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 7,
                    total: 0,
                    kpoker_mode: -1,
                    union_id: undefined,
                    union_ids: [],
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <Cascader
                        showSearch
                        allowClear
                        changeOnSelect
                        options={this.state.subUnionList}
                        placeholder={this.props.language["unionPlaceholder"]}
                        value={this.state.queryParams.union_ids}
                        onChange={(value) => this.handleSetQueryParamsData("union_ids", value)}
                    />
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        loading={this.state.exportLoading}
                        onClick={this.handleExport}
                    >
                        {this.props.language["exportExcel"]}
                    </Button>
                    <Button
                        type="default"
                        icon="arrow-down"
                        className="btn-yellow-ghost"
                        onClick={() => this.handleShow("exportCheckData")}
                    >
                        {this.props.language["exportCheckData"]}
                    </Button>
                    <Button
                        type="primary"
                        ghost
                        onClick={() => this.handleShow('intervalSummaryData')}
                    >
                        {this.props.language["intervalSummaryData"]}
                    </Button>
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.state.data, "day")}
                        pagination={false}
                        loading={this.state.loading}
                        scroll={{ x: true }}
                        rowKey={'key'}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/union_detail/${item.union_id}`}>
                                    {item.union_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionName"]}
                            dataIndex="union_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalGaveIn"]}
                            dataIndex="total_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfit"]}
                            dataIndex="profit_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeZC"]}
                            dataIndex="fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceZC"]}
                            dataIndex="ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyZC"]}
                            dataIndex="cowboy_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["luckcardAndJackpotProfit"]}
                            dataIndex="lc_jp_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityBouns"]}
                            dataIndex="activity_bonus"
                        />

                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeGiveIn"]}
                                dataIndex="api_prop_cost_gain_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["totalIncome"]}
                            dataIndex="total_income"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeesIncome"]}
                            dataIndex="fee_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceIncome"]}
                            dataIndex="ins_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboysIncome"]}
                            dataIndex="cowboy_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["LCAndJPIncome"]}
                            dataIndex="lc_jp_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityCost"]}
                            dataIndex="active_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeContribution"]}
                            dataIndex="fee_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceInvestmentAmount"]}
                            dataIndex="ins_buy_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProfit"]}
                            dataIndex="ins_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyBettingAmount"]}
                            dataIndex="cb_buy_in_sum"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeContribution"]}
                                dataIndex="api_prop_cost_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhProfit"]}
                            dataIndex="nlh_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofProfit"]}
                            dataIndex="aof_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcProfit"]}
                            dataIndex="ofc_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttProfit"]}
                            dataIndex="mtt_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploProfit"]}
                            dataIndex="plo_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixProfit"]}
                            dataIndex="six_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProfit"]}
                            dataIndex="cb_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductFee"]}
                            dataIndex="nlh_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofDeductFee"]}
                            dataIndex="aof_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcDeductFee"]}
                            dataIndex="ofc_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttDeductFee"]}
                            dataIndex="mtt_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductFee"]}
                            dataIndex="plo_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductFee"]}
                            dataIndex="six_fee_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductFee"]} dataIndex="cb_fee_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductInsurance"]}
                            dataIndex="nlh_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["aofDeductInsurance"]} dataIndex="aof_ins_profit_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["ofcDeductInsurance"]} dataIndex="ofc_ins_fee_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["mttDeductInsurance"]} dataIndex="mtt_ins_profit_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductInsurance"]}
                            dataIndex="plo_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductInsurance"]}
                            dataIndex="six_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductInsurance"]} dataIndex="cb_ins_profit_sum" /> */}
                    </Table>
                    <div className="pagination">
                        <Pagination
                            showQuickJumper
                            size={isMobileDevice() ? 'small' : ''}
                            showTotal={(total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["day"]}`
                            }
                            current={this.state.queryParams.page}
                            pageSize={this.state.queryParams.limit}
                            total={this.state.queryParams.total}
                            onChange={(current, pageSize) =>
                                this.hanldeChangePage({ current, pageSize })
                            }
                        />
                        {!isMobileDevice() &&
                            <Select
                                className="ml10"
                                value={this.state.queryParams.limit}
                                onChange={(value) =>
                                    this.hanldeChangePage({ current: 1, pageSize: value })
                                }
                            >
                                {this.state.pageSizeList.map((item, index) => (
                                    <Select.Option value={item.value} key={index}>
                                        {item.label}
                                    </Select.Option>
                                ))}
                            </Select>
                        }
                    </div>
                </div>

                {/* 导出弹窗 */}
                <ExportFormModal
                    {...this.props}
                    visible={this.state.showForm}
                    type={this.state.formType}
                    title={this.state.formTitle}
                    formData={this.state.formData}
                    typeList={this.state.typeList}
                    subUnionList={this.state.subUnionList}
                    dataTypeList={this.state.dataTypeList}
                    onOk={this.handleCheckExport}
                    onCancel={() => this.handleClose('exportCheckData')}
                    wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                />

                {/* 查看记录弹窗 */}
                <RecordModal
                    {...this.props}
                    visible={this.state.showRecord}
                    title={this.state.recordTitle}
                    type={this.state.recordType}
                    loading={this.state.recordLoading}
                    intervalSummaryData={this.state.intervalSummaryData}
                    onCancel={() => this.handleClose('intervalSummaryData')}
                />
            </div>
        );
    }
}

/**
 * 导出弹窗
 */
const ExportFormModal = Form.create({ name: "form_model" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
            return (
                <Modal
                    maskClosable={false}
                    width={600}
                    title={this.props.title}
                    visible={this.props.visible}
                    onOk={this.props.onOk}
                    onCancel={this.props.onCancel}
                    centered={isMobileDevice()}
                    bodyStyle={{
                        maxHeight: '70vh',
                        overflowY: "auto",
                    }}
                >
                    <div className="container-content">
                        <Form>
                            <Form.Item label={this.props.language["type"]}>
                                {getFieldDecorator("type", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["typeVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.type,
                                })(
                                    <Radio.Group>
                                        {this.props.typeList.map(
                                            (item, index) => (
                                                <Radio key={index} value={item.value}>{item.label}</Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>
                            {getFieldValue('type') === 2 &&
                                <Form.Item label={this.props.language["union"]}>
                                    {getFieldDecorator("union_ids", {
                                        rules: [
                                            {
                                                required: true,
                                                message: this.props.language["unionVerify"],
                                            },
                                        ],
                                        initialValue: this.props.formData.union_ids,
                                    })(
                                        <TreeSelect
                                            showSearch
                                            multiple
                                            treeCheckable
                                            showCheckedStrategy={TreeSelect.SHOW_CHILD}
                                            treeData={this.props.subUnionList}
                                            placeholder={this.props.language["unionPlaceholder"]}
                                        />
                                    )}
                                </Form.Item>
                            }
                            <Form.Item label={this.props.language["timeRange"]}>
                                {getFieldDecorator("date", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["timeRangeVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.date,
                                })(
                                    <DatePicker.RangePicker />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["emailAccount"]}>
                                {getFieldDecorator("email", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["emailAccountVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.email,
                                })(
                                    <Input
                                        maxLength={60}
                                        allowClear
                                        placeholder={this.props.language["emailAccountPlaceholder"]}
                                    />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.language["dataType"]}>
                                {getFieldDecorator("data_type", {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.language["dataTypeVerify"],
                                        },
                                    ],
                                    initialValue: this.props.formData.data_type,
                                })(
                                    <Radio.Group>
                                        {this.props.dataTypeList.map(
                                            (item, index) => (
                                                <Radio key={index} value={item.value}>{item.label}</Radio>
                                            )
                                        )}
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Form>
                    </div>
                </Modal>
            );
        }
    }
);

/**
 * 查看记录弹窗
 */
class RecordModal extends React.Component {
    render () {
        return (
            <Modal
                maskClosable={false}
                width={1600}
                title={this.props.title}
                visible={this.props.visible}
                onCancel={this.props.onCancel}
                centered={isMobileDevice()}
                bodyStyle={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                }}
                footer={null}
            >
                <div className="container-content">
                    <Table
                        dataSource={tableSummaries(this.props.intervalSummaryData, "day")}
                        pagination={false}
                        loading={this.props.loading}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["date"]}
                            dataIndex="day"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionId"]}
                            dataIndex=""
                            render={(item) => (
                                <Link to={`/union_detail/${item.union_id}`}>
                                    {item.union_id || ''}
                                </Link>
                            )}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["unionName"]}
                            dataIndex="union_name"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["totalGaveIn"]}
                            dataIndex="total_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["playerProfit"]}
                            dataIndex="profit_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeZC"]}
                            dataIndex="fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceZC"]}
                            dataIndex="ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyZC"]}
                            dataIndex="cowboy_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["luckcardAndJackpotProfit"]}
                            dataIndex="lc_jp_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityBouns"]}
                            dataIndex="activity_bonus"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeGiveIn"]}
                                dataIndex="api_prop_cost_gain_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["totalIncome"]}
                            dataIndex="total_income"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeesIncome"]}
                            dataIndex="fee_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceIncome"]}
                            dataIndex="ins_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboysIncome"]}
                            dataIndex="cowboy_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["LCAndJPIncome"]}
                            dataIndex="lc_jp_income_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["activityCost"]}
                            dataIndex="active_cost"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFeeContribution"]}
                            dataIndex="fee_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceInvestmentAmount"]}
                            dataIndex="ins_buy_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["insuranceProfit"]}
                            dataIndex="ins_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyBettingAmount"]}
                            dataIndex="cb_buy_in_sum"
                        />
                        {Cookie.get("isKpoker") === 'true' &&
                            <Table.Column
                                align="center"
                                title={this.props.language["propCusomeContribution"]}
                                dataIndex="api_prop_cost_sum"
                            />
                        }
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhProfit"]}
                            dataIndex="nlh_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofProfit"]}
                            dataIndex="aof_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcProfit"]}
                            dataIndex="ofc_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttProfit"]}
                            dataIndex="mtt_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploProfit"]}
                            dataIndex="plo_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixProfit"]}
                            dataIndex="six_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["cowboyProfit"]}
                            dataIndex="cb_profit_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductFee"]}
                            dataIndex="nlh_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["aofDeductFee"]}
                            dataIndex="aof_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ofcDeductFee"]}
                            dataIndex="ofc_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["mttDeductFee"]}
                            dataIndex="mtt_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductFee"]}
                            dataIndex="plo_fee_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductFee"]}
                            dataIndex="six_fee_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductFee"]} dataIndex="cb_fee_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["nlhDeductInsurance"]}
                            dataIndex="nlh_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["aofDeductInsurance"]} dataIndex="aof_ins_profit_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["ofcDeductInsurance"]} dataIndex="ofc_ins_fee_sum" /> */}
                        {/* <Table.Column align="center" title={this.props.language["mttDeductInsurance"]} dataIndex="mtt_ins_profit_sum" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["ploDeductInsurance"]}
                            dataIndex="plo_ins_gain_sum"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["sixDeductInsurance"]}
                            dataIndex="six_ins_gain_sum"
                        />
                        {/* <Table.Column align="center" title={this.props.language["cowboyDeductInsurance"]} dataIndex="cb_ins_profit_sum" /> */}
                    </Table>
                </div>
            </Modal>
        );
    }
}

